import { Injectable } from '@angular/core';
import SwiperCore, { A11y, Autoplay, Navigation, Pagination, Scrollbar, SwiperOptions } from 'swiper';

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

@Injectable({
  providedIn: 'root',
})
export class SwiperService {

  public SwiperConfig(config: any): SwiperOptions {

    // navigation: {
    //   nextEl: ".ico-Right",
    //   prevEl: ".ico-Left"
    //  }
    return {
      slidesPerView: config.slide,
      spaceBetween: 15,
      preloadImages: false,
      grabCursor: true,
      slideToClickedSlide: true,
      lazy: {
        enabled:config.lazy ? config.lazy : true,
        loadPrevNext:true,
        checkInView:true

      } ,
     autoplay: config.autoplay,
      navigation: config.navigation,
      pagination: config.pagination && !config.pagination.isMobile ? config.pagination : {},
      loop: config.loop,
      grid: {
        rows: 1,
      },

      breakpoints: {
        320: {
          slidesPerView: config.slide,
          loop: config.loop,
          pagination: config.pagination && config.pagination.isMobile ?  config.pagination : {},
          spaceBetween: 20,
          lazy: {
            enabled:config.lazy ? config.lazy : true,
            loadPrevNext:true,
            checkInView:true
          } ,
          grid: {
            rows: 1,
          },
          autoplay: {
            delay: 3000,
          },
        },
        768: {
          slidesPerView: config.slide,
          loop: config.loop,
          lazy: {
            enabled:config.lazy ? config.lazy : true,
            loadPrevNext:true,
            checkInView:true

          } ,
          pagination: config.pagination && config.pagination.isMobile ?  config.pagination : {},
          spaceBetween: 30,
          grid: {
            rows: 1,
          },
          autoplay: {
            delay: 3000,
          },
        },
        1200: {
          slidesPerView: config.slide,
          loop: config.loop,
          lazy: {
            enabled:config.lazy ? config.lazy : true,
            loadPrevNext:true,
            checkInView:true
          } ,
          spaceBetween: 15,
          grid: {
            rows: 1,
          },
          autoplay: {
            delay: 3000,
          },
        },
      },
    };
  }
}
